import { FabricObject, StaticCanvas } from 'fabric';
import { AttachToConfig, applyAllAttachTo } from './attach-to';
import { buildPieceIdIndex } from '../../canvas/utils/piece-id';

export const getAttachTo = (obj: FabricObject): AttachToConfig | undefined => obj.attachTo;

/** Writes a new attachTo config and reapplies the chain so the canvas reflects it. */
export const setAttachTo = (obj: FabricObject, cfg: AttachToConfig, canvas: StaticCanvas): void => {
  obj.attachTo = cfg;
  applyAllAttachTo(canvas);
  canvas.requestRenderAll();
};

/** Removes the attachment. The object stays at its current position. */
export const clearAttachTo = (obj: FabricObject, canvas: StaticCanvas): void => {
  obj.attachTo = undefined;
  canvas.requestRenderAll();
};

/** Lists pieceIds available as anchor candidates, excluding the given object itself. */
export const listAnchorablePieceIds = (canvas: StaticCanvas, excludeSelf: FabricObject): string[] => {
  const pieceIds: string[] = [];
  buildPieceIdIndex(canvas).forEach((obj, pieceId) => {
    if (obj !== excludeSelf) pieceIds.push(pieceId);
  });
  return pieceIds;
};
